import { Box } from '@mui/material'
import type { PropsWithChildren } from 'react'
import { styles } from './styles'

export const DrawerFooter = (props: PropsWithChildren) => {
  const { children } = props
  return <Box sx={styles.root}> {children}</Box>
}
